import React from 'react'
import { Container, Box, Typography ,Button} from '@mui/material'
import { Termsdata } from '../assets/data';
import Footer from '../components/Footer';
import ArrowBtn from '../components/ArrowBtn';
import useMediaQuery from '@mui/material/useMediaQuery';
import termimg from "../assets/termD.png";
import { Link } from 'react-router-dom';

const Terms = () => {

  const matches = useMediaQuery('(max-width:500px)');

  return (
    <>
      <Box className="Hero_main"
                style={{ backgroundImage: `url(${termimg})`, height: matches ? '100vh' : '120vh' }} >
                <Box className="hero_div">
                    <h1 className='herotitle'>
                    WeCare <br /> Terms of Service
                    </h1>
                    <Link to='/BookRepair'>
                        <Button variant="contained" className='herobtn1' >
                            Get a Quote
                        </Button>
                    </Link>
                </Box>
            </Box>
      <Container maxWidth="xl">
        <Box className="terms_main">
          {Termsdata.map((item, i) => (
            <Box key={i} className="termsDiv">
              <Typography variant="h5" className='faq_title'>{item.title}</Typography>
              <Typography variant="body1" className='faq_desc'>{item.desc}</Typography>
            </Box>
          ))}

        </Box>
      </Container>
      <Footer />
    </>
  )
}

export default Terms
